export const gost = {
    gost_21_613_f6: {
        tag: { label: 'Обозначение кабеля, провода', type: 'text' },
        sourceLocation: { label: 'Трасса начало', type: 'text' },
        destinationLocation: { label: 'Трасса конец', type: 'text' },
        markProject: { label: 'Марка кабеля по проекту', type: 'text' },
        coresProject: { label: 'Количество кабелей и сечение жил по проекту', type: 'text' },
        lengthProject: { label: 'Длина кабеля по проекту', type: 'number' },
        markActual: { label: 'Марка кабеля проложенная', type: 'text' },
        coresActual: { label: 'Количество кабелей и сечение жил проложенная', type: 'text' },
        lengthActual: { label: 'Длина кабеля проложенная', type: 'number' },
        pullBoxNumber: { label: 'Протяжный ящик №', type: 'text' },
        conduitTag: { label: 'Проход через трубу обозначение', type: 'text' },
        conduitType: { label: 'Проход через трубу диаметр по стандарту, мм', type: 'text' },
        conduitLength: { label: 'Проход через трубу длина, м', type: 'number' },
        note: { label: 'Примечание', type: 'text' },
    },
    gost_21_613_f7: {
        tag: { label: 'Обозначение кабеля, провода', type: 'text' },
        sourceLocation: { label: 'Трасса начало', type: 'text' },
        destinationLocation: { label: 'Трасса конец', type: 'text' },
        markProject: { label: 'Марка кабеля по проекту', type: 'text' },
        coresProject: { label: 'Количество кабелей и сечение жил по проекту', type: 'text' },
        lengthProject: { label: 'Длина кабеля по проекту', type: 'number' },
        markActual: { label: 'Марка кабеля проложенная', type: 'text' },
        coresActual: { label: 'Количество кабелей и сечение жил проложенная', type: 'text' },
        lengthActual: { label: 'Длина кабеля проложенная', type: 'number' },
        routeDetails: { label: 'Участок трассы кабеля, провода', type: 'text' },
        note: { label: 'Примечание', type: 'text' },
    },
    gost_21_608_f6: {
        tag: { label: 'Обозначение кабеля, провода', type: 'text' },
        sourceLocation: { label: 'Трасса начало', type: 'text' },
        destinationLocation: { label: 'Трасса конец', type: 'text' },
        markProject: { label: 'Марка кабеля по проекту', type: 'text' },
        coresProject: { label: 'Количество кабелей и сечение жил по проекту', type: 'text' },
        lengthProject: { label: 'Длина кабеля по проекту', type: 'number' },
        markActual: { label: 'Марка кабеля проложенная', type: 'text' },
        coresActual: { label: 'Количество кабелей и сечение жил проложенная', type: 'text' },
        lengthActual: { label: 'Длина кабеля проложенная', type: 'number' },
        note: { label: 'Примечание', type: 'text' },
    },
    gost_70444: {
        tag: { label: 'Обозначение кабеля, провода', type: 'text' },
        sourceLocation: { label: 'Трасса начало', type: 'text' },
        destinationLocation: { label: 'Трасса конец', type: 'text' },
        markProject: { label: 'Марка кабеля по проекту', type: 'text' },
        coresProject: { label: 'Количество кабелей и сечение жил по проекту', type: 'text' },
        lengthProject: { label: 'Длина кабеля по проекту', type: 'number' },
        installationTag: { label: 'Проход трассы: обозначение (маркировка)', type: 'text' },
        installationType: { label: 'Проход трассы: характеристика', type: 'text' },
        installationLength: { label: 'Проход трассы: длина, м', type: 'number' },
        note: { label: 'Примечание', type: 'text' },
    },
}